









































































import { defineComponent, SetupContext } from '@nuxtjs/composition-api';

export default defineComponent({
  props: {
    url: {
      type: String,
      default: '',
    },
    pageNo: {
      type: Number,
      default: 1,
    },
    totalPages: {
      type: Number,
      default: 0,
    },
  },
  setup(props, context: SetupContext) {
    // ページネーションリンクをクリックした時の処理
    const paginationLinkClickHandler = () => {
      context.emit('paginationLinkClickHandler');
    };

    return {
      paginationLinkClickHandler,
    };
  },
});
